import { NorthEast } from "@mui/icons-material";
import { Box, Grid2, Typography, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import { colors } from "../../theme/theme";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ErrorSnackbar } from "./CustomSnackbar";

const AnalyticsBox = ({
  title,
  number,
  per,
  schedule,
  bottomText,
  dollar,
  small,
  tboxes,
  setCalenderComponentState,
  isSubscribed,
  teir,
  isSelf,
  visitingId,
}) => {
  const navigate = useNavigate();
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });
  return (
    <Grid2
      item
      size={{
        xs: tboxes ? 12 : 6,
        sm: tboxes ? 12 : 6,
        md: 4,
        lg: small ? 4 : 3,
      }}
    >
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      <Box
        sx={{
          border: "1px solid #000",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          p: smallScreen ? 1 : 2,
          position: "relative",
        }}
      >
        {schedule && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              borderBottom: "1px solid #000",
              borderLeft: "1px solid #000",
              p: 0.5,
              height: smallScreen ? "20px" : "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NorthEast
              sx={{
                color: colors.primary,
                fontSize: smallScreen ? "10px" : "32px",
              }}
            />
          </Box>
        )}
        <Typography
          sx={{
            fontSize: smallScreen ? "10px" : "14px",
            fontFamily: "Inter-SemiBold",
            color: "#000",
            textTransform: "uppercase",
          }}
        >
          {title}
        </Typography>
        {schedule ? (
          <Typography
            sx={{
              fontSize: smallScreen ? "12px" : "24px",
              fontFamily: "Inter-Light",
              color: colors.primary,
              textDecorationLine: "underline",
              mb: smallScreen ? 0 : 1,
              mt: smallScreen ? 0 : 0.5,
              cursor: "pointer",
            }}
            onClick={() => {
              if (isSelf) {
                if (smallScreen) {
                  navigate("/calendar");
                } else {
                  setCalenderComponentState(true);
                }
              } else if (!isSubscribed) {
                setErrorState({
                  error: true,
                  message: "You are not subscribed.",
                });
              } else if (!teir.accessDynamicCalender) {
                setErrorState({
                  error: true,
                  message: "current package does not include dynamic calendar.",
                });
              } else {
                if (smallScreen) {
                  navigate("/calendar", {
                    state: {
                      visitingId: visitingId || null,
                    },
                  });
                } else {
                  setCalenderComponentState(true);
                }
              }
            }}
          >
            Schedule event
          </Typography>
        ) : (
          <Typography
            sx={{
              fontSize: smallScreen ? "12px" : "32px",
              fontFamily: "Inter-Bold",
              color: "#000",
              mt: bottomText ? 0.5 : 0,
            }}
          >
            {dollar && (
              <Typography
                component={"span"}
                sx={{
                  fontSize: smallScreen ? "12px" : "23px",
                  fontFamily: "Inter-Bold",
                  color: "#000",
                }}
              >
                $
              </Typography>
            )}
            {number + " "}
          </Typography>
        )}

        {bottomText && (
          <Typography
            sx={{
              fontSize: "14px",
              fontFamily: "Inter-Medium",
              color: colors.primary,
              textDecorationLine: "underline",
              mt: 1.5,
            }}
          >
            Download report
          </Typography>
        )}
      </Box>
    </Grid2>
  );
};

export default AnalyticsBox;
